let isEnabledSubscribed = false;
let isEnabledInitial = false;

export function getIsDeviceIdEnabledSubscribed(): boolean {
    return isEnabledSubscribed;
}

export function setIsDeviceIdEnabledSubscribed(value: boolean): void {
    isEnabledSubscribed = value;
}

export function getIsDeviceIdEnabledInitial(): boolean {
    return isEnabledInitial;
}

export function setIsDeviceIdEnabledInitial(value: boolean): void {
    isEnabledInitial = value;
}
